import instance from '../utils/axios';

const WIKI_API_BASE = 'https://xtool-wiki.gson.workers.dev';

export const wikiApi = {
    listDocs() {
        return instance.get(`${WIKI_API_BASE}/wiki/list`);
    },

    getDoc(id) {
        return instance.get(`${WIKI_API_BASE}/wiki/${id}`);
    },

    createDoc(data) {
        return instance.post(`${WIKI_API_BASE}/wiki`, data);
    },

    updateDoc(id, data) {
        return instance.put(`${WIKI_API_BASE}/wiki/${id}`, data);
    },

    deleteDoc(id) {
        return instance.delete(`${WIKI_API_BASE}/wiki/${id}`);
    },

    searchDocs(query) {
        return instance.get(`${WIKI_API_BASE}/wiki/search?q=${encodeURIComponent(query)}`);
    },

    lookupWord(word) {
        return instance.post(`${WIKI_API_BASE}/wiki/word-lookup`, { word });
    }
};

export default wikiApi;
